document.addEventListener("alpine:init", () => {
  Alpine.store("navigationStore", {
    on: false,
    inverted: false,
    isOverflowHidden: false,

    open() {
      this.inverted = true;
      this.on = true;
      this.toggleOverflowHidden();
    },

    close() {
      this.inverted = false;
      this.on = false;
      this.toggleOverflowHidden();

    },

    toggleOverflowHidden() {
      this.isOverflowHidden = !this.isOverflowHidden;
      document.body.style.overflow = this.isOverflowHidden ? 'hidden' : 'auto';
    },

    toggle() {
      if (this.on) {
        this.close();
      } else {
        this.open();
      }
    },

    checkScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.inverted = scrollTop > 0;
    }
  });


  // Add scroll event listener to toggle `inverted` property
  window.addEventListener("scroll", () => {
    Alpine.store("navigationStore").checkScroll();
  });
});
